import { CompanyDetailAndJobGroups } from '@types';
import type { TFunction } from 'i18next';
import { ModalPanelTabType } from 'redesign';
import { SettingsDetail } from '../settings-detail/settings-detail';
import { SettingsDetailTheme } from '../settings-theme/setting-detail-theme';

export const getSettingsDetailTabs = (
  companyData: CompanyDetailAndJobGroups,
  t: TFunction<'ogp-screen-specific' | 'web-common', undefined>
) => {
  const tabs: (ModalPanelTabType | null)[] = [
    {
      id: 'company-settings',
      tabLabel: t('settings-detail.tab', { ns: 'ogp-screen-specific' }),
      element: <SettingsDetail companyData={companyData} />,
    },
    companyData.company.themeCustomizationEnabled
      ? {
          id: 'company-themes',
          tabLabel: t('settings-theme.tab', { ns: 'ogp-screen-specific' }),
          element: <SettingsDetailTheme />,
        }
      : null,
  ];

  return tabs.filter((tab): tab is ModalPanelTabType => tab !== null);
};
